import { useCallback, useContext, useState } from "react";
import useApi from "./useApi";
import useModal from "./useModal";
import { getReportList } from "apis/generate-report.api";
import { UserContext, StationContext, DownloadsContext } from "contexts";

const REPORT_LOOKUP_DELAY = 3000;

const useExport = ({ api, reportType, mappedFilterState }) => {
  const { request } = useApi({ api, params: api.params });
  const { request: fetchLatestReport } = useApi({ api: getReportList, handleOwnError: true });
  const { user } = useContext(UserContext);
  const { station } = useContext(StationContext);
  const { addPendingDownload, completeDownload } = useContext(DownloadsContext);
  const [loading, setLoading] = useState(false);
  const downloadProgressModal = useModal();

  const exportReport = useCallback(
    async ({ fileType } = {}) => {
      const filterState = {
        ...mappedFilterState,
        ...(fileType ? { fileType } : {}),
        connectionId: localStorage.getItem("connectionId"),
      };
      delete filterState.page;
      delete filterState.perPage;

      try {
        setLoading(true);
        const resp = await request({ ...filterState, reportType });
        setLoading(false);
        downloadProgressModal.show();
        addPendingDownload(resp?.fileName);

        // the report is generated in the background, small ones may already be ready after a moment
        setTimeout(async () => {
          try {
            const res = await fetchLatestReport({
              page: 1,
              perPage: 1,
              orderBy: "createdAt",
              order: "desc",
              userId: user?.userId,
              stationId: station?.stationId,
              reportTypes: reportType,
            });
            const latest = res?.reports?.[0];
            if (latest?.fileUrl && latest.fileName === resp?.fileName) {
              completeDownload(latest.fileName, latest.reportId);
              window.open(latest.fileUrl, "_blank");
            }
          } catch {
            // the Downloads page will show the report once it is ready
          }
        }, REPORT_LOOKUP_DELAY);
      } catch {
        setLoading(false);
      }
    },
    [request, reportType, mappedFilterState, fetchLatestReport, user?.userId, station?.stationId, addPendingDownload, completeDownload, downloadProgressModal],
  );

  return { exportReport, exporting: loading, downloadProgressModal };
};

export default useExport;
